import styled from 'styled-components'
import Background from './layout/Background'
import Container from './layout/Container'
import Stack from './layout/Stack'
import { StyledArticleGrid } from './article/Article'
import Link from './Link'
import { humanList } from '../lib/strings'
import textLink from '../styles/textLink'

function StoriesFooter( { sectionTitle, stories } ) {
  return (
    <Background color="blueGrey__light">
      <Container>
        <Stack
          top={ 3 }
          bottom={ 3 }
        >
          <StyledArticleGrid 
            style={ { paddingBottom: 0 } }
            $gridType="story"
            $hasTwoCols
            $collapseArticleInfoMargin
            $collapseArticleContentMargin
          >
            <div>
              <StyledHeader>
                { sectionTitle }
              </StyledHeader>
            </div>
            <div>
              <StyledCards>
                { stories.map( story => (
                  <StoryCard
                    key={ story.id }
                    story={ story }
                  />
                ) )}
              </StyledCards>
            </div>
          </StyledArticleGrid>
        </Stack>
      </Container>
    </Background>
  )
}

function StoryCard( { story } ) {
  const storyAuthors = humanList( story.entryAuthor.map( author => author.title ) )

  return (
    <Link href={ `/stories/${ story.slug }` }>
      <h4>{ story.title }</h4>
      { storyAuthors.length > 0 && <p>By { storyAuthors }</p> }
    </Link>
  )
}

const StyledHeader = styled.h3`
  margin: 0 0 1rem 0;
  ${ p => p.theme.typo.generalSansSemiBold }
  color: ${ p => p.theme.colors.red };
`

const StyledCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -0.5rem -1rem;

  > * {
    flex: 1 1 50%;
    box-sizing: border-box;
    padding: 0.5rem 1rem;
    min-width: 285px;
    max-width: 400px;
  }

  a {
    text-decoration: none;
    color: inherit;

    h4 {
      margin: 0;
      ${ p => p.theme.typo.generalSansSemiBold }
      ${ textLink }
      text-decoration-color: transparent;
      transition: text-decoration-color .3s ease-out;
    }

    p {
      margin: 0.5rem 0 0 0;
      font-size: ${ p => p.theme.typo.sizes.dropped };
    }

    &:hover h4 {
      text-decoration-color: ${ p => p.theme.colors.red };
    }
  }
`

export default StoriesFooter
